'use strict'

// scripts
import functions from "./src/functions"
import { sendToZap } from "./src/zapier"
import meters from "./src/meter"

// config 
export { createConfig } from "./src/config.js";
export { config } from "./src/config.js";

const date = functions.date;
const time = functions.time;
const getImage = functions.getImage;
const validateInput = functions.validateInput;
// meter
const meter = {
    analog:     meters.AnalogMeter,
    balance:    meters.midPointerMeter
}

// zapier
const zap = sendToZap;

export { date, time, getImage, validateInput, meter, zap }; 

const script = {
    // functions
    date,
    time,
    getImage,
    validateInput,
    // meter
    meter,
    // zapier
    zap
};

export default { script };

